import React from "react";
import ReactDiffViewer from "react-diff-viewer";

const diffViewerStyles = {
  variables: {
    light: {
      diffViewerBackground: "#fff",
      diffViewerTitleBackground: "#fafafa",
      addedBackground: "#e6ffed",
      addedColor: "#24292e",
      removedBackground: "#ffeef0",
      removedColor: "#24292e",
      wordAddedBackground: "#acf2bd",
      wordRemovedBackground: "#fdb8c0",
    },
  },
  contentText: {
    fontSize: "14px",
    fontFamily: "monospace",
    userSelect: "text",
  },
};

// Normalize cosmetic whitespace so the diff only highlights real content
// changes. The rewrite LLM sometimes re-spaces lines (e.g. "-  x" -> "- x") or
// collapses blank lines; that would otherwise show identical text as both
// removed and added. Preserves leading indentation (nesting), collapses runs of
// inner spaces/tabs, strips trailing whitespace, and caps blank-line runs.
const normalizeWhitespace = (s) =>
  (s || "")
    .split("\n")
    .map((line) => {
      const lead = line.match(/^[ \t]*/)[0];
      const rest = line.slice(lead.length).replace(/[ \t]+/g, " ").replace(/[ \t]+$/, "");
      return lead + rest;
    })
    .join("\n")
    .replace(/\n{3,}/g, "\n\n");

const PromptDiffViewer = ({
  oldValue,
  newValue,
  leftTitle = "Current Instructions",
  rightTitle = "Optimized Instructions",
  showDiffOnly = false,
}) => {
  const leftValue = normalizeWhitespace(oldValue);
  const rightValue = normalizeWhitespace(newValue);

  return (
    <div>
      <div className="border rounded-lg overflow-hidden" style={{ userSelect: "text" }}>
        <ReactDiffViewer
          oldValue={leftValue}
          newValue={rightValue}
          splitView={true}
          leftTitle={leftTitle}
          rightTitle={rightTitle}
          showDiffOnly={showDiffOnly}
          useDarkTheme={false}
          styles={diffViewerStyles}
          compareMethod="diffWords"
          hideLineNumbers={false}
          extraLinesSurroundingDiff={3}
        />
      </div>
    </div>
  );
};

export default PromptDiffViewer;
